// *******************************************************************************
// Menu toggle
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  // Open menu
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.mobile-hamburger');

  const isOpen = hamburger.classList.contains('is-open');

  hamburger.classList.toggle('is-open', !isOpen);
  hamburger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 5);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

// *******************************************************************************
// Open search
// *******************************************************************************

attachEvent('.header-main__search-btn', 'click', (ev) => {
  document.body.classList.remove('is-open-menu');
  const searchInput = document.querySelector('.search-box__input-field');

  if (document.body.classList.contains('is-open-search')) {
    document.body.classList.remove('is-open-search');
    searchInput.blur();
  } else {
    document.body.classList.add('is-open-search');
    searchInput.focus();
  }
});

// *******************************************************************************
// Close search modal when escape key press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.body.classList.remove('is-open-search');
  }
});

// *******************************************************************************
// Close search modal when clicking on black overlay
// *******************************************************************************

document.addEventListener('click', (evt) => {
  const headerSearchContainer = document.querySelector('.header-main__search');
  const headerSearchBtn = document.querySelector('.header-main__search-btn');
  let targetElement = evt.target; // clicked element

  do {
    // eslint-disable-next-line max-len
    if (targetElement === headerSearchContainer || targetElement === headerSearchBtn) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  document.body.classList.remove('is-open-search');
});
